function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7672_38666)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.4418 0H15.5582C6.96564 0 0 6.96564 0 15.5582V54.4418C0 63.0344 6.96564 70 15.5582 70H54.4418C63.0344 70 70 63.0344 70 54.4418V15.5582C70 6.96564 63.0344 0 54.4418 0Z",
  fill: "#434343"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1414 15.2891C10.6064 15.2891 8.75 17.4465 8.75 20.6805V49.3182C8.75 52.5529 10.6064 54.7096 14.1414 54.7096H55.8579C59.3929 54.7096 61.2493 52.5522 61.2493 49.3182V20.6805C61.2493 17.4458 59.3929 15.2891 55.8579 15.2891H14.1414Z",
  fill: "#D9D6CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5671 17.5C11.7692 17.5 10.9355 19.1772 10.9355 21.2597V34.9678L23.2842 34.9909C26.5833 34.9972 27.9343 36.3244 29.3091 38.1815C29.6591 38.6547 30.0854 39.2952 30.5012 39.7117C31.743 40.9549 33.3719 41.5758 35.0001 41.5758C36.629 41.5758 38.2572 40.9549 39.499 39.7117C39.9148 39.2952 40.3411 38.6547 40.6911 38.1815C42.0659 36.3244 43.4169 34.9972 46.716 34.9909L59.0648 34.9678V21.2597C59.0648 19.1765 58.2318 17.5 55.4332 17.5H14.5671Z",
  fill: "#F16D5E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5671 17.5C11.7692 17.5 10.9355 19.1772 10.9355 21.2597V25.6515C10.9355 23.5683 11.7685 21.8918 14.5671 21.8918H55.4325C58.2304 21.8918 59.0641 23.569 59.0641 25.6515V21.2597C59.0641 19.1765 58.2311 17.5 55.4325 17.5H14.5671Z",
  fill: "#3295C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5671 21.8906C11.7692 21.8906 10.9355 23.5678 10.9355 25.6503V30.0421C10.9355 27.9589 11.7685 26.2824 14.5671 26.2824H55.4325C58.2304 26.2824 59.0641 27.9596 59.0641 30.0421V25.6503C59.0641 23.5671 58.2311 21.8906 55.4325 21.8906H14.5671Z",
  fill: "#FCAD00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5671 26.2852C11.7692 26.2852 10.9355 27.9624 10.9355 30.0449V34.4367C10.9355 32.3535 11.7685 30.677 14.5671 30.677H55.4325C58.2304 30.677 59.0641 32.3542 59.0641 34.4367V30.0449C59.0641 27.9617 58.2311 26.2852 55.4325 26.2852H14.5671Z",
  fill: "#50BE3D"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7672_38666"
}, /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 70,
  fill: "white"
})));

var SvgAppleWallet = function SvgAppleWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppleWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apple_wallet.abe84760.svg";
export { ForwardRef as ReactComponent };